// extracted by mini-css-extract-plugin
export default {"container":"Qr-z","heading":"Rr-z","text":"Sr-z","info":"Tr-z","link":"Ur-z","fullMaxWidth":"Vr-z"};